@if (mentions(); as picked) {
  @if (picked.length > 0) {
    <div class="mention-chips" data-testid="ai-agent-mentions">
      @for (mention of picked; track mention.id) {
        <soft-ds-chip
          size="sm"
          variant="outline"
          removable
          leadingIcon="fa-regular fa-at"
          (remove)="removeMention(mention.id)"
        >
          {{ mention.label }}
        </soft-ds-chip>
      }
    </div>
  }
}

<div class="row">
  <soft-ds-input
    class="composer-input"
    type="text"
    data-testid="ai-agent-input"
    [value]="draft()"
    [disabled]="disabled()"
    [placeholder]="'#AI_AGENT.PLACEHOLDER' | translate"
    (valueChange)="draft.set($event)"
    (input)="syncCaret()"
    (keyup)="syncCaret()"
    (click)="syncCaret()"
    (keydown)="onKeydown($event)"
  />
  <soft-ds-button
    variant="primary"
    data-testid="ai-agent-send"
    [disabled]="disabled() || (draft() ?? '').trim().length === 0"
    (click)="submit()"
  >
    <ng-template softSlot="leading">
      <soft-ds-icon name="fa-regular fa-paper-plane" />
    </ng-template>
    @if (!compact()) {
      {{ '#AI_AGENT.SEND' | translate }}
    }
  </soft-ds-button>
</div>

<!-- The overlay takes its body as a TemplateRef. Its <ng-content> fallback is
     only reached in dialog mode, so projected markup would render nowhere. -->
<ng-template #pickerBody>
  @if (stage() === 'entity') {
    <div class="mention-entities" data-testid="ai-agent-mention-entities" role="listbox">
      <p class="ds-caption mention-hint">
        {{ '#AI_AGENT.MENTION_PICK_ENTITY' | translate }}
      </p>
      @for (entity of entities(); track entity.name; let i = $index) {
        <button
          type="button"
          role="option"
          class="mention-entity"
          [class.is-highlighted]="i === highlighted()"
          [attr.aria-selected]="i === highlighted()"
          [attr.data-testid]="'ai-agent-mention-entity-' + entity.name"
          (mouseenter)="highlighted.set(i)"
          (click)="selectEntity(entity.name)"
        >
          <soft-ds-icon [name]="entity.icon" />
          <span class="ds-body-2">{{ entity.label }}</span>
        </button>
      }
    </div>
  } @else {
    <div class="mention-picker" data-testid="ai-agent-mention-picker">
      <div class="mention-picker-header">
        <soft-ds-button
          variant="ghost"
          size="sm"
          data-testid="ai-agent-mention-back"
          (click)="backToEntities()"
        >
          <ng-template softSlot="leading">
            <soft-ds-icon name="fa-regular fa-chevron-left" />
          </ng-template>
          {{ activeEntityLabel() }}
        </soft-ds-button>
        <soft-ds-button
          variant="ghost"
          size="sm"
          data-testid="ai-agent-mention-close"
          [attr.aria-label]="'#AI_AGENT.MENTION_CLOSE' | translate"
          (click)="closePicker()"
        >
          <ng-template softSlot="leading">
            <soft-ds-icon name="fa-regular fa-xmark" />
          </ng-template>
        </soft-ds-button>
      </div>

      @for (entityName of activeEntityNames(); track entityName) {
        <soft-masterdata-input
          class="mention-search"
          inline
          autoFocus
          clearOnPick
          [entity]="entityName"
          [showLabel]="false"
          [initialSearchTerm]="searchSeed()"
          (picked)="applyRecord($event)"
        />
      }
    </div>
  }
</ng-template>

<soft-ds-overlay
  [(open)]="open"
  [originElement]="host"
  [content]="pickerBody"
  [trapFocus]="false"
  [autoCaptureFocus]="false"
  [maxHeight]="stage() === 'entity' ? 280 : 520"
  [width]="stage() === 'entity' ? 280 : 560"
  [dividers]="false"
/>
